// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__7JUlE","buttons":"PendingPaymentAlert_buttons__1vNeL"};